import * as React from 'react';
import { ItemValidationResult, Reason } from '../../domain/Order';

interface Props {
    itemValidationResult: ItemValidationResult[];
    label: string;
}

class ValidationResult extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <>
                <div className="popup-text popup-table-text">{this.props.label}</div>
                <div className="popup-table">
                    <div className="table-header">
                        <div>SKU</div>
                        <div>Typed quantity</div>
                        <div>Ordered quantity</div>
                        <div>Order type</div>
                        <div>Reason</div>
                    </div>
                    <div className="table-body">
                        {this.props.itemValidationResult.map(correctedOrder => (
                            <div className="table-row" key={correctedOrder.sku}>
                                <div>{correctedOrder.sku}</div>
                                <div>{correctedOrder.placed}</div>
                                <div>{correctedOrder.corrected}</div>
                                <div>{correctedOrder.type.toUpperCase()}</div>
                                <div>{this.translateReason(correctedOrder.reason)}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </>
        );
    }

    private translateReason = (reason: Reason): string => {
        switch (reason) {
            case 'insufficientLevel':
                return 'Insufficient level';
            case 'itemNotEnabled':
                return 'Item not enabled';
            case 'liabilityNotMet':
                return 'Liability not met';
            case 'packageSizeError':
                return 'Rounded to package size';
            case 'exceedsAvailableInCheckout':
                return 'Rounded down to the highest available';
            case 'wrongOrderValues':
                return 'Not a number';
            case 'notEstimated':
                return 'Not estimated';
        }
    };
}

export default ValidationResult;



// WEBPACK FOOTER //
// ./src/view/popup/ValidationResult.tsx